import Vue from 'vue';
import App from './app';
import router from '@src/router';
import store from '@state/store';
import '_globals';
import appConfig from '@src/app.config.ES6';
import initInterceptors from './utils/interceptors';
import i18n from './i18n';
import Leanplum from 'leanplum-sdk';
import Bugsnag from '@bugsnag/js';

Vue.config.devtools = appConfig.NODE_ENV !== 'production';

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = appConfig.NODE_ENV === 'production';

Leanplum.setAppIdForProductionMode(appConfig.LP_APP_ID, appConfig.LP_APP_KEY);
Leanplum.start();

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException;
} else {
  Vue.config.errorHandler = (err, vm, info) => {
    // Log properties passed to the component if there are any
    if (vm.$options.propsData) {
      console.log('Props passed to component', vm.$options.propsData);
    }

    // Emit component name and also the lifecycle hook the error occurred in if present
    var infoMessage = `Error in component: <${vm.$options._componentTag} />\n`;
    if (info) {
      infoMessage += `Error occurred during lifecycle hook: ${info}\n`;
    }

    // This puts the additional error information in the Telemetry Timeline
    console.log(infoMessage);

    // Track the native JS error
    Bugsnag.notify(new Error(err));
  };
}

initInterceptors();

const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// If running inside Cypress...
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app;
}
